import React from "react";
import { Button, TextField, Typography } from "@mui/material";
import Flex from "../../components/Flex";
import {
  abortDraft,
  commitDraft,
  fetchDraftDiff,
  selectDraftMode,
  selectLensEditorLens,
  selectLensEditorRuleSerial,
  selectRules,
  selectRulesAdded,
  selectRulesMetadataEdit,
  selectRulesQueryChanged,
  selectRulesRemoved,
} from "../../redux/slices/lensEditor";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import triggerDownload from "../../helpers/triggerDownload";
import { Refresh } from "@mui/icons-material";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { RuleMode } from "routes/lens-editor/RuleMode";

const DiffSummary = () => {
  const dispatch = useAppDispatch();
  const snackpatch = useAppDispatchWithSnackbar();

  const lens = useAppSelector(selectLensEditorLens);

  const ruleSerial = useAppSelector(selectLensEditorRuleSerial);

  const lensId = lens.id;

  const [fileName, setFileName] = React.useState("");

  const handleAbortDraft = () => {
    dispatch(abortDraft({ lensId }));
  };
  const handleCommitDraft = async () => {
    dispatch(commitDraft({ lensId }));
  };

  const loadDraftDiff = () => {
    snackpatch(fetchDraftDiff({ lensId }), {
      errorMessage: "Failed to fetch draft diff",
    });
  };

  const isDraftMode = useAppSelector(selectDraftMode);

  const addedRules = useAppSelector(selectRulesAdded);
  const removedRules = useAppSelector(selectRulesRemoved);

  const draftQueryChangedDiffs = useAppSelector(selectRulesQueryChanged);
  const draftMetadataEditDiffs = useAppSelector(selectRulesMetadataEdit);

  const allRules = useAppSelector(selectRules);

  const saveToFile = () => {
    const trimmedRules = allRules.map((r) => ({
      ...r,
      subtype: r.subtype.trim(),
      description: r.description.trim(),
    }));
    const data = JSON.stringify({ rules: trimmedRules, ruleIdSerial: ruleSerial });
    triggerDownload(new Blob([data], { type: "application/json" }), fileName);
  };

  if (!isDraftMode) {
    return (
      <Flex>
        <Typography>No draft</Typography>
      </Flex>
    );
  }

  return (
    <Flex>
      <Button size="small" onClick={loadDraftDiff} startIcon={<Refresh />}>
        Refresh
      </Button>
      <Flex>
        <Typography>Added</Typography>
        {addedRules.map((newRule, idx) => (
          <RuleMode readOnly key={idx} rule={newRule} />
        ))}
        <Typography>Removed</Typography>
        {removedRules.map((oldRule, idx) => (
          <RuleMode readOnly key={idx} rule={oldRule} />
        ))}
        <Typography>Changed</Typography>
        <Typography>{draftQueryChangedDiffs.length}</Typography>
        <Typography>Moved</Typography>
        <Typography>{draftMetadataEditDiffs.length}</Typography>
      </Flex>
      <Flex flexDirection="row">
        <Button size="small" onClick={handleAbortDraft} color="error">
          Abort Draft
        </Button>
        <Button size="small" onClick={handleCommitDraft}>
          Commit Draft
        </Button>
      </Flex>
      <Flex flexDirection="row">
        <TextField label="File Name" value={fileName} onChange={(evt) => setFileName(evt.target.value)} />
        <Button disabled={fileName.length <= 0} onClick={() => saveToFile()} size="small">
          Save Draft to File
        </Button>
      </Flex>
    </Flex>
  );
};

export default DiffSummary;
